module.exports = __webpack_public_path__ + "media/images/site/check-5a085858ab2f335cf385b38c4933aeca.svg";